import React, { useRef, useState, useLayoutEffect } from "react";
import styled from "styled-components";
import { ReactComponent as Play } from "../assets/svg/play.svg";
import { ReactComponent as Stop } from "../assets/svg/stop.svg";

const AudioPlay = ({ audio, className, isAutoplay = false, onEnd }) => {
  const [state, setState] = useState(isAutoplay ? "PLAYING" : null);

  const audioRef = useRef(undefined);

  useLayoutEffect(() => {
    if (!audioRef.current) return;

    if (state === null) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.volume = 1;
    } else if (state === "PLAYING") audioRef.current.play();
  }, [state]);

  const onClick = () =>
    setState((prevState) => {
      let state = null;
      if (prevState === "WAITING") state = "WAITING";
      else if (prevState === "PLAYING") state = null;
      else if (prevState === null) state = "PLAYING";

      return state;
    });

  useLayoutEffect(() => {
    if (isAutoplay) setState("PLAYING");
    else setState(null);
  }, [isAutoplay]);

  return (
    <Container className={className}>
      {audio && (
        <>
          <audio
            ref={audioRef}
            autoPlay={isAutoplay}
            onEnded={() => {
              setState(null);
              if (typeof onEnd === "function") {
                onEnd();
              }
            }}
            onWaiting={() => setState("WAITING")}
            onPlaying={() => setState("PLAYING")}
          >
            <source src={audio} type="audio/mpeg" />
          </audio>
          <ButtonWrapper onClick={onClick}>
            {state === "PLAYING" && <ButtonStop as={Stop} />}
            {state === null && <ButtonPlay as={Play} />}
            {state === "WAITING" && <Spinner src="loading.gif" />}
          </ButtonWrapper>
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  pointer-events: all;
`;

const ButtonStop = styled.div`
  fill: #bdbdbd;
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
`;

const ButtonPlay = styled.div`
  fill: #2196f3;
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
`;

const ButtonWrapper = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

export default AudioPlay;
